import { render, staticRenderFns } from "./OrderSummarySection.vue?vue&type=template&id=0a58c114&scoped=true&"
import script from "./OrderSummarySection.vue?vue&type=script&lang=js&"
export * from "./OrderSummarySection.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummarySection.vue?vue&type=style&index=0&id=0a58c114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a58c114",
  null
  
)

export default component.exports